export default "__VITE_ASSET__a08baa4f__"